module.exports = __webpack_public_path__ + "static/media/ic_date_payment.251de52e.svg";